module.exports = __webpack_public_path__ + "img/calendar-alt.19c9f850.svg";